import { Separator } from '@monksflow/monks-ui';

/**
 * Divider for the rail's popover menus.
 *
 * Two deliberate departures from the design system's own menu separator, both
 * from this app's design: it is inset from the panel edges rather than bleeding
 * to them, and it uses the lighter `--border-light` where the design system
 * specifies `--border` (confirmed against Figma — the darker value is correct
 * for the system, and lighter is correct here).
 *
 * The colour is a class rather than a token re-point because the design system
 * has no separator token to point at. Revisit if one appears, or when these
 * popovers become `DropdownMenu`, whose separator carries its own rhythm.
 */
export function MenuSeparator() {
  // The width class matches the design system's own `data-[orientation=…]` variant:
  // a plain `w-auto` loses to it on specificity and the rule overflows the panel.
  return <Separator className="mx-2xs bg-border-light data-[orientation=horizontal]:w-auto" />;
}
